import React from 'react'
import { connect } from 'react-redux'
import SchedulerActions from '../../Redux/SchedulerRedux'
import moment from 'moment'

class DeleteScheduler extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'DD-MM-YYYY / h:mm:ss a'
    this.state = {}
  }

  _submit = () => {
    let data = { id: this.props.id }
    setTimeout(() => {
      this.props.deleteScheduler(data)
      setTimeout(() => {
        this.props.closeModal()
      }, 300)
    }, 300)
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw' }}>
        <div className='title-block'>
          <h1 className='title'>Delete Scheduler</h1>
        </div>
        <div>
          <p className='text-center'>
            Scheduler Name: <strong>{this.props.title}</strong>
          </p>
          <p className='text-center'>
            Date / Time: <strong>{moment(this.props.date).format(this.dateformat)}</strong>
          </p>
          <p className='text-center'>
            Product Type: <strong>{this.props.product}</strong>
          </p>
        </div>
        <div className='row'>
          <div className='text-right col-12'>
            <button className='btn btn-danger' onClick={() => this._submit()}>
              Delete
            </button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  scheduler: state.scheduler
})

const dispatchToProps = (dispatch) => ({
  deleteScheduler: (data) => dispatch(SchedulerActions.deleteSchedulerRequest(data))
})

export default connect(stateToProps, dispatchToProps)(DeleteScheduler)



// WEBPACK FOOTER //
// ./src/Containers/Scheduler/DeleteScheduler.js